import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const namespacePrefix = 'page-components';
const supportedLanguages = ['en'];
const fallbackLanguage = 'en';
function createDefaultI18nextInstance() {
    const i18n = i18next.createInstance({
        ns: [
            `${namespacePrefix}-common`,
            `${namespacePrefix}-giftaid`,
            `${namespacePrefix}-termsAndConditions`,
            `${namespacePrefix}-event`,
            `${namespacePrefix}-qrCode`,
            `${namespacePrefix}-loadingIndicator`,
            `${namespacePrefix}-pageCard`,
            `${namespacePrefix}-share`,
        ],
        fallbackLng: fallbackLanguage,
        defaultNS: `${namespacePrefix}-common`,
        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
        react: {
            useSuspense: false,
        },
    });
    i18n
        .use({
        type: 'backend',
        init() { },
        read(language, namespace, callback) {
            loadTranslations(language, namespace)
                .then((translations) => callback(null, translations))
                .catch((error) => callback(error, null));
        },
    })
        .use(LanguageDetector)
        .init();
    return i18n;
}
async function loadTranslations(language, namespace) {
    if (!namespace.startsWith(namespacePrefix)) {
        return null;
    }
    if (!supportedLanguages.includes(language)) {
        language = fallbackLanguage;
    }
    namespace = namespace.substring(namespacePrefix.length + 1);
    const translations = await import(`../locales/${language}/${namespace}.json`);
    return translations.default ?? translations;
}

export { createDefaultI18nextInstance, fallbackLanguage, loadTranslations, namespacePrefix, supportedLanguages };
//# sourceMappingURL=i18n.js.map
